import { render } from "./SidebarAdmin.vue?vue&type=template&id=f95cd4ae&scoped=true"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js"

import "./SidebarAdmin.vue?vue&type=style&index=0&id=f95cd4ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f95cd4ae"]])

export default __exports__